import {
  HttpClient,
  HttpErrorResponse,
  HttpParams
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Guid } from 'src/app/helpers/guid';
import { urlsNotification } from 'src/app/helpers/urls';
import { NotificationModuleType } from 'src/app/models/notification/notification-module-type';
import { NotificationRuleBaseDto } from 'src/app/models/notification/notification-rule-base-dto';
import { NotificationRuleDto } from 'src/app/models/notification/notification-rule-dto';
import { NotificationRuleWorkItemDto } from 'src/app/models/notification/notification-rule-work-item-dto';
import { CommonService } from '../../common.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationRulesService {
  private http = inject(HttpClient);
  private commonService = inject(CommonService);

  private useMock: boolean = false;

  getNotificationRules$(
    type: NotificationModuleType
  ): Observable<NotificationRuleDto[]> {
    if (this.useMock) {
      return of(this.mockRules());
    }

    let params = new HttpParams();
    params = params.set('type', type);
    return this.http
      .get<
        NotificationRuleDto[]
      >(`${urlsNotification.notificationRules}`, { params: params })
      .pipe(
        catchError((error: HttpErrorResponse) =>
          this.commonService.handleError$(error)
        )
      );
  }

  getNotificationRule$(id: number): Observable<NotificationRuleDto> {
    return this.http
      .get<NotificationRuleDto>(`${urlsNotification.notificationRules}/${id}`)
      .pipe(
        catchError((error: HttpErrorResponse) =>
          this.commonService.handleError$(error)
        )
      );
  }

  addNotificationRule$(
    createRule: NotificationRuleBaseDto
  ): Observable<NotificationRuleDto> {
    if (this.useMock) {
      const result: NotificationRuleDto = {
        id: Guid.generate(),
        ...createRule
      };
      return of(result);
    }

    return this.http
      .post<NotificationRuleDto>(
        `${urlsNotification.notificationRules}`,
        createRule
      )
      .pipe(
        catchError((error: HttpErrorResponse) =>
          this.commonService.handleError$(error)
        )
      );
  }

  deleteNotificationRule$(
    id: string,
    type: NotificationModuleType
  ): Observable<boolean> {
    if (this.useMock) {
      return of(true);
    }

    let params = new HttpParams();
    params = params.set('type', type);

    return this.http
      .delete<boolean>(`${urlsNotification.notificationRules}/${id}`, {
        params: params
      })
      .pipe(
        catchError((error: HttpErrorResponse) =>
          this.commonService.handleError$(error)
        )
      );
  }

  updateNotificationRule$(
    updateNotificationRule: NotificationRuleDto
  ): Observable<NotificationRuleDto> {
    if (this.useMock) {
      return of(updateNotificationRule);
    }

    return this.http
      .put<NotificationRuleDto>(
        `${urlsNotification.notificationRules}/${updateNotificationRule.id}`,
        updateNotificationRule
      )
      .pipe(
        catchError((error: HttpErrorResponse) =>
          this.commonService.handleError$(error)
        )
      );
  }

  private mockRules(): NotificationRuleDto[] {
    const result: NotificationRuleWorkItemDto[] = [
      // {
      //   id: 'id-111',
      //   name: 'name-111',
      //   type: NotificationModuleType.WorkItem,
      //   clientIds: [9044127, 2784076],
      //   processNodeIds: ['144343-144384-144385', '144343-144384-144386', '144343-144388'],
      //   status: [ 5 ]
      // },
      {
        id: 'id-222',
        name: 'name-222',
        type: NotificationModuleType.WorkItem,
        clientIds: [9044127],
        processNodeIds: ['144343', '144343-144388', '144343-144384-144385'],
        statuses: [5]
      }
    ];

    return result;
  }
}
